import { getReferrerAttribution } from "@outschool/attribution";
import { isLocalStorageSupported } from "@outschool/local-storage";

export const POST_LOGIN_PATH_LOCAL_STORAGE_NAME = "POST_LOGIN_PATH";

/**
 * Same-origin path for a post-login redirect. Off-site values are dropped so
 * callers can navigate to the result without an open redirect.
 */
export function safeLoginRedirect(
  redirect: string | null | undefined,
): string | undefined {
  if (!redirect) {
    return undefined;
  }

  // No origin to compare against during server render. Keep root-relative
  // paths and reject anything that could leave the site.
  if (typeof window === "undefined") {
    if (
      redirect.startsWith("/") &&
      !redirect.startsWith("//") &&
      !redirect.startsWith("/\\")
    ) {
      return redirect;
    }
    return undefined;
  }

  try {
    const url = new URL(redirect, `${window.location.origin}/`);
    if (url.origin !== window.location.origin) {
      return undefined;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return undefined;
  }
}

export const getPostLoginPath = (): string | undefined | null => {
  // referral postLoginPath
  const { landingPage, usid } = getReferrerAttribution();
  if (usid && landingPage) {
    return safeLoginRedirect(landingPage);
  }

  const storage = isLocalStorageSupported();
  if (!storage) {
    return undefined;
  }

  const stored = storage.getItem(POST_LOGIN_PATH_LOCAL_STORAGE_NAME);
  if (!stored) {
    return stored;
  }

  const safePath = safeLoginRedirect(stored);
  if (!safePath) {
    storage.removeItem(POST_LOGIN_PATH_LOCAL_STORAGE_NAME);
    return undefined;
  }
  return safePath;
};
